export default {
    name: "BlogFeedback",
    props: {
        info: {
            type: Object,
            default: () => ({}),
        }
    },
}